import { getCurrentWebviewWindow } from "@tauri-apps/api/webviewWindow";
import { useEffect, useState } from "react";

export function useWindowFocused() {
	const [visible, setVisible] = useState(true);
	useEffect(() => {
		const unlisten = getCurrentWebviewWindow().onFocusChanged((e) => {
			setVisible(e.payload);
		});

		return () => void unlisten.then((fn) => fn());
	}, []);

	return visible;
}
